import { useContext, useState } from "react";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";

export const useAPIEditDepartment = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  //  API call section

  const fetchData = async ({ id, extraData }) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/department/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        const newData = reformatDataAfterFetch(_data);
        if (extraData) {
          setData({ ...extraData, ...newData });
        } else {
          setData(newData);
        }
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/masterdata/department/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        const newData = reformatDataAfterFetch(_data);
        onConfirmed(newData);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!data.kode || data.kode === "") {
      newEror = { ...newEror, kode: "Kode tidak boleh kosong" };
      valid = false;
    }

    if (!data.nama || data.nama === "") {
      newEror = { ...newEror, nama: "Nama tidak boleh kosong" };
      valid = false;
    }

    setError(newEror);
    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;

    return newData;
  };

  const reformatDataAfterFetch = (_data) => {
    return _data;
  };

  const fetchDataOrCreateNew = ({ id, extraData }) => {
    if (id && id > 0) {
      fetchData({ id, extraData });
    } else {
      if (extraData) {
        setData({ ...generateNewData(), ...extraData });
      } else {
        setData(generateNewData());
      }
    }
  };

  const generateNewData = () => {
    return {
      kode: "",
      nama: "",
      status: 1,
      keterangan: "",
    };
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    error,
    setError,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
